import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import { State } from '../../store'
import store from '@/store/store'
import router from '@/router'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import ComponentState from './states'
import { Menu } from '@/services/Menus'
import liff from '@line/liff'

const actions: ActionTree<ComponentState, State> = {
  changeApp(
    { commit, state }: ActionContext<ComponentState, State>,
    app: string,
  ): void {
    if (app) {
      localStorage.setItem('app', app)
    } else {
      localStorage.removeItem('app')
    }
    commit(mutationType.APP, app)
    const menus: Menu[] = store.getters['components/menuSidebar']
    const menu = _.head(menus)
    const result = menu && menu.route
    router.push(app && result || '/')
  },
  updateTitlePage(
    { commit, dispatch, state }: ActionContext<ComponentState, State>,
    title: string,
  ): void {
    commit(mutationType.TITLEPAGE, title)
  },
  updateSnackbar(
    { commit, dispatch, state }: ActionContext<ComponentState, State>,
    data: {
      id: string
      txt: string
      type: string,
    },
  ): void {
    const newSnackbar = state.snackbar || []
    newSnackbar.push(data)
    data.id = uuidv4().toString()
    commit(mutationType.SNACKBAR, newSnackbar)
    setTimeout(() => {
      dispatch('closeSnackbar', data.id)
    }, 5000)
  },
  closeSnackbar(
    { commit, state }: ActionContext<ComponentState, State>,
    id: string,
  ): void {
    const newSnackbar = state.snackbar || []
    commit(
      mutationType.SNACKBAR,
      _.filter(newSnackbar, (snack) => snack.id !== id),
    )
  },
  pageStartLoading(
    { commit, state }: ActionContext<ComponentState, State>,
  ): void {
    commit(mutationType.PAGE_START_LOADING)
  },
  pageStopLoading(
    { commit, state }: ActionContext<ComponentState, State>,
  ): void {
    commit(mutationType.PAGE_STOP_LOADING)
  },
  setLevel(
    { commit, state }: ActionContext<ComponentState, State>,
    level: {id?: string, mode: string},
  ): void {
    if (!_.isEqual(state.user.level, level)) {
      localStorage.setItem('level', JSON.stringify(level))
      commit(mutationType.SET_LEVEL, level)
      const menus: Menu[] = store.getters['components/menuSidebar']
      // const menuExits = _.find(menus, (menu) => router.currentRoute.fullPath.startsWith(`/main/${menu.route}`))
      // if (!menuExits) {
      //   const menu = _.head(menus)
      //   const result = menu && menu.route
      //   router.push(result)
      // }
    }
  },
  setReady(
    { commit, state }: ActionContext<ComponentState, State>,
    isReady: boolean,
  ) {
    commit(mutationType.READY, isReady)
  },
  async sendMsgInLine(
    { commit, state }: ActionContext<ComponentState, State>,
    messages: any,
  ): Promise<void> {
    if (liff.getOS() !== 'web') {
      await liff.sendMessages(messages)
    }
  },
}

export default actions
